<!-- copyright -->
<template>
  <span class="copyright-panel">
    {{ $t('copyright', { year }) }}
  </span>
</template>

<script>
export default {
  name: 'Copyright',
  data () {
    return {}
  },
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/copyright/index.vue